module.exports = __webpack_public_path__ + "img/logo_76.cb3f1b4c.png";